import { render, staticRenderFns } from "./MultilateralDynamics.vue?vue&type=template&id=983e0eae&scoped=true"
import script from "./MultilateralDynamics.vue?vue&type=script&lang=js"
export * from "./MultilateralDynamics.vue?vue&type=script&lang=js"
import style0 from "./MultilateralDynamics.vue?vue&type=style&index=0&id=983e0eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e0eae",
  null
  
)

export default component.exports